import {
  getStudentList,
  getStudentAssignmentList,
  getStudentById,
  getStudentListByClassId,
  deleteStudentClass,
  changeCenter,
  changeCenterPeriod,
  updateStudent,
  //Değerlendirme Aşaması öğrencileri
  getEvaluateCertificateStudentList,
  getPaymentList,
  finderStudentFiltered,
  loadStudentScores,
} from "@/services/student.service";

import {
  getClassById,
} from "@/services/class.service";

import {  formatDateEditZone } from "@/utils/utils";
import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({
  studentModel: {
    classId: null,
  },

  findStudentModel: {
    classId: null,
  },

  newStudentModel: {
    // FirstName: "Manuel Ad 3",
    // LastName: "Manuel Soyad 3",
    // GenderId: 1,
    // DateOfBirth: "1998-01-01",
    // NationalitysId: 150,
    // phoneCode: 225,
    // Tel: "505982564848",
    // Email: "yeeogrenci@hotmail.com",
    // Adress: "Adress Satır",
    // countryId: 225,
    // citiesId: 107139,
    // LevelsId: 1,
    // EducationTypeId: 2,
    // PaidId: 2,
    // ClassId: null,
    // File: null,
    photo: "",
  },

  studentInfoModel: {},

  studentList: [],
  findStudentsList: [],
  studentScoreList: [],
  selectedStudents: [],

  studentAssignModel: {},
});

// mutations
const mutations = {
  setStudentModel(state, data) {
    state.studentModel = data;
  },

  setNewStudentModel(state, data) {
    state.newStudentModel = data;
  },

  setStudentInfoModel(state, data) {
    state.studentInfoModel = data;
  },

  setStudentList(state, data) {
    state.studentList = data;
  },

  setFindStudentModel(state, data) {
    state.findStudentModel = data;
  },
  
  findStudentList(state, data) {
    state.findStudentsList = data;
  },
  
  setStudentScores(state, data) {
    state.studentScoreList = data;
  },
   
  setSelectedStudents(state, data) {
    state.selectedStudents = data;
  },

  setStudentAssignModel(state, data) {
    state.studentAssignModel = data;
  },
};

// actions
const actions = {
  async loadEvaluateCertificateStudentList(vuexContext, co) {
    return await getEvaluateCertificateStudentList(co).then(async (response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.fullname = item.firstName + " " + item.lastName;
        item.studentClassStatus = `${item.classStatusMulti?.classStatus?.startTime} - ${item.classStatusMulti?.classStatus?.endTime} / ${item.classStatusMulti?.classStatus?.levels?.description}`;
        item.uniqueId = item.id + "" + item.classStatusMultiId;
      });
      return data;
    });
  },

  //Öğrenci Listesi
  async loadStudentList(vuexContext, co) { 
    return await getStudentList(co).then(async (response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        if (index === 0) item.active = true;
        else item.active = false;
        item.index = index + 1;

        item.studentClassName = item.userStudentClassList?.find((s) => s.active && s.class?.active)?.class?.name;

        if (item.lastClassStatus) {
          item.lastStatus = item.lastClassStatus.levelsDto?.description + " / " + item.lastClassStatus.classStatusDto?.startTime + " - " + item.lastClassStatus.classStatusDto?.endTime;
        }

        if (item.userStudentDto) {
          item.userStudentDto.name = item.userStudentDto?.firstName;
          item.fullName = item.userStudentDto ? `${item.userStudentDto.firstName} ${item.userStudentDto.lastName}` : "";
          item.userStudentId = item.userStudentDto ? item.userStudentDto.id : undefined;
          item.email = item.userStudentDto.email;
        }
        item.disabled = item.studentSelectionDto?.id === 1 ? true : false;

        /**** */
        item.classDayAndTime = "";
        item.dayAndTime = "";
        if (item.classDayAndTimeList && item.classDayAndTimeList.length < 1) {
          item.classDayAndTime = "Veri girişi yapılmadı.";
          item.dayAndTime = "Veri girişi yapılmadı.";
        }

        item.classDayAndTimeList?.forEach((dayTime, index) => {
          //TSİ
          item.classDayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, dayTime.classTemp.timePeriod, "+03:00")} - ${formatDateEditZone(
            dayTime.endDate,
            dayTime.classTemp.timePeriod,
            "+03:00"
          )}
          `;
          if (index < item.classDayAndTimeList.length - 1) {
            item.classDayAndTime += " / ";
          }

          //Normal
          item.dayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} -  ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
          `;
          if (index < item.classDayAndTimeList.length - 1) {
            item.dayAndTime += " / ";
          }
        });

        item.newName = item.name + " / " + item.timePeriod;
        /**** */
      });

      setPaginationDetails(co, totalCount, totalPages);

      vuexContext.commit("setStudentList", items);
      return items;
    });
  },

  async findStudentFiltered(vuexContext, co) {
    return await finderStudentFiltered(co).then(async (response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        if (index === 0) item.active = true;
        else item.active = false;
        item.index = index + 1;

        item.studentClassName = item.userStudentClassList?.find((s) => s.active && s.class?.active)?.class?.name;

        if (item.lastClassStatus) {
          item.lastStatus = item.lastClassStatus.levelsDto?.description + " / " + item.lastClassStatus.classStatusDto?.startTime + " - " + item.lastClassStatus.classStatusDto?.endTime;
        }

        if (item.userStudentDto) {
          item.userStudentDto.name = item.userStudentDto?.firstName;
          item.fullName = item.userStudentDto ? `${item.userStudentDto.firstName} ${item.userStudentDto.lastName}` : "";
          item.userStudentId = item.userStudentDto ? item.userStudentDto.id : undefined;
          item.email = item.userStudentDto.email;
        }
        item.disabled = item.studentSelectionDto?.id === 1 ? true : false;

        /**** */
        item.classDayAndTime = "";
        item.dayAndTime = "";
        if (item.classDayAndTimeList && item.classDayAndTimeList.length < 1) {
          item.classDayAndTime = "Veri girişi yapılmadı.";
          item.dayAndTime = "Veri girişi yapılmadı.";
        }

        item.classDayAndTimeList?.forEach((dayTime, index) => {
          //TSİ
          item.classDayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, dayTime.classTemp.timePeriod, "+03:00")} - ${formatDateEditZone(
            dayTime.endDate,
            dayTime.classTemp.timePeriod,
            "+03:00"
          )}
          `;
          if (index < item.classDayAndTimeList.length - 1) {
            item.classDayAndTime += " / ";
          }

          //Normal
          item.dayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} -  ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
          `;
          if (index < item.classDayAndTimeList.length - 1) {
            item.dayAndTime += " / ";
          }
        });

        item.newName = item.name + " / " + item.timePeriod;
        /**** */
      });

      setPaginationDetails(co, totalCount, totalPages);

      vuexContext.commit("findStudentList", items);
      return items;
    });
  },

  async loadStudentScore(vuexContext, co) {
    return await loadStudentScores(co).then(async (response) => {
      let items = response.data.data;
      items.map((item, index) => {
        (index === 0)
        item.index = index + 1;
        if(item.changedTime.includes("0001"))
        {
          item.changedTime = "";
        }
      });
      vuexContext.commit("setStudentScores", items);
      return items;
    });
  },

  async loadClassById(vuexContext, classId) {
    return await getClassById(classId).then((response) => {
      let data = response.data.data;
      //console.log("mm",data);
      data.map((item,index)=>{
        item.index = index+1;
       });
      vuexContext.commit("setStudentList", data);
      return data;
    });
  },

  //ödeme listesi
  async loadStudentPaymentList(vuexContext, co) {
    return await getPaymentList(co).then(async (response) => {
      let data = response.data.data;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      let items = data.items;

      items.map((item, index) => {
        item.index = index + 1;
        item.totalPrice = item.amount + " " + item.currencyCode;
        // item.studentClassName = item.userStudentClassList?.find((s) => s.active && s.class?.active)?.class?.name;
        if (item.lastClassStatus) {
          item.lastStatus = item.lastClassStatus.levelsDto?.description + " / " + item.lastClassStatus.classStatusDto?.startTime + " - " + item.lastClassStatus.classStatusDto?.endTime;
        }
        if (item.userStudentDto) {
          item.userStudentDto.name = item.userStudentDto?.firstName;
          item.fullName = item.userStudentDto ? `${item.userStudentDto.firstName} ${item.userStudentDto.lastName}` : "";
          //item.userStudentId = item.userStudentDto ? item.userStudentDto.id : undefined;
          item.email = item.userStudentDto.email;
        }
      });

      setPaginationDetails(co, totalCount, totalPages);

      vuexContext.commit("setStudentList", items);
      return items;
    });
  },

  async loadStudentAssigmentList(vuexContext, co) {
    return await getStudentAssignmentList(co).then(async (response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        if (item.userStudentDto) {
          item.userStudentDto.name = item.userStudentDto?.firstName;
          item.fullName = item.userStudentDto ? `${item.userStudentDto.firstName} ${item.userStudentDto.lastName}` : "";
          item.userStudentId = item.userStudentDto ? item.userStudentDto.id : undefined;
          item.email = item.userStudentDto.email;
        }
      });
      return data;
    });
  },

  async loadStudentById(vuexContext, studentId) {
    return await getStudentById(studentId).then((response) => {
      let data = response.data.data;
      // data.lessonHours = "";
      // data.days = [];

      // if (data.personDto?.personId > 0) {
      //   data.lecturerFullName = data.personDto?.name + " " + data.personDto?.lastName;
      // } else {
      //   data.lecturerFullName = null;
      // }

      // //if (data.levelDashBoardDto.length > 0) data.levelDashBoardDto[0].active = true;

      // data.studentAllClassStatusMulti = [];
      // data.studentScores = [];
      // data.scoringLevelDashboardDto.map((scoreLevel, index) => {
      //   let pushItem = { id: index + 1, labels: {}, label: "" };
      //   scoreLevel.scoringDashboardDto.map((scoreStatus, index) => {
      //     pushItem[scoreStatus.scoringTypeDto.id] = scoreStatus.score;
      //     pushItem.labels[scoreStatus.scoringTypeDto.id] = scoreStatus.scoringTypeDto.name;
      //     if (scoreLevel.scoringDashboardDto.length <= index + 1) {
      //       pushItem.label = scoreStatus.levelsDto.description + " " + scoreStatus.classStatusDto.startTime + " - " + scoreStatus.classStatusDto.endTime;
      //       data.studentAllClassStatusMulti.push(pushItem);
      //     }

      //     data.studentScores.push(scoreStatus);
      //   });
      // });

      // //sınıfa atanmışsa
      // if (data.studentDto && data.studentDto.length > 0) {
      //   let studentDto = data.studentDto[0];
      //   data.classId = studentDto.classId;
      //   data.className = `${studentDto.className} (${studentDto.level})`;
      //   data.educationTypeName = studentDto.educationType;
      //   data.linkAdress = studentDto.linkAdress;
      //   data.attendanceCount = studentDto.attendanceCount;
      //   data.level = studentDto.level;

      //   data.classZoom = studentDto.classZoom;
      //   data.timezone = studentDto.timezone;

      //   let activeClassStatus = studentDto.classStatusListDTO?.find((s) => {
      //     return s.active === true;
      //   });
      //   if (activeClassStatus) {
      //     data.classStartDate = activeClassStatus.startDate;
      //     data.classEndDate = activeClassStatus.endDate;
      //     data.activeClassStatus = `${activeClassStatus?.classStatusDto?.startTime} - ${activeClassStatus?.classStatusDto?.endTime}`;
      //   }

      //   data.videoList = studentDto.videoListDTO;

      //   data.eventList = studentDto.eventListDTO;

      //   studentDto.classDayAndTimeStudentDto.forEach((dayAndTime) => {
      //     data.lessonHours += dayAndTime.dayDto.name + " (" + formatDateToHour(dayAndTime.startDate) + " - " + formatDateToHour(dayAndTime.endDate) + ") <br />";
      //     data.days.push({
      //       startTime: dayAndTime.startDate,
      //       endTime: dayAndTime.endDate,
      //       dayId: dayAndTime.dayId === 7 ? 0 : dayAndTime.dayId,
      //     });
      //   });
      // }

      // //sınıfa atanmamış manuel
      // else {
      //   data.classId = null;
      //   data.className = null;
      //   data.educationTypeName = null;
      //   data.linkAdress = null;
      //   data.attendanceCount = null;
      //   data.level = null;
      //   data.activeClassStatus = null;
      //   data.videoList = [];
      //   data.eventList = [];
      //   data.lessonHours = null;
      // }

      // if (data.userStudentUpdateDto) {
      //   let userStudentUpdateDto = data.userStudentUpdateDto;
      //   data.tel = userStudentUpdateDto.tel;
      //   data.dateOfBirth = userStudentUpdateDto.dateOfBirth;
      //   data.adress = userStudentUpdateDto.adress;
      //   data.id = userStudentUpdateDto.Id;
      // }

      // if (data.userStudentDto) {
      //   let userStudentDto = data.userStudentDto;

      //   data.firstName = userStudentDto.firstName;
      //   data.lastName = userStudentDto.lastName;

      //   data.fullName = `${userStudentDto.firstName} ${userStudentDto.lastName}`;
      //   data.genderId = userStudentDto.genderId;
      //   data.email = userStudentDto.email;
      //   data.nationalitysId = userStudentDto.nationalitysId;
      //   data.nationalitysId2 = userStudentDto.nationalitysId2;
      //   data.nationalitysId3 = userStudentDto.nationalitysId3;
      //   data.countryId = userStudentDto.countryId;
      //   data.stateId = userStudentDto.statesId;
      //   data.cityId = userStudentDto.citiesId;
      //   data.centerId = userStudentDto.centerId;

      //   data.imagePath = userStudentDto.imagePath;
      //   if (userStudentDto.imagePath) {
      //     fetch(process.env.VUE_APP_SSO_URL + "uploads/profil/" + userStudentDto.imagePath)
      //       .then((res) => res.blob())
      //       .then((blob) => {
      //         data.File = new File([blob], "profil.png", blob);
      //       });
      //     data.photo = process.env.VUE_APP_SSO_URL + "uploads/profil/" + data.imagePath;
      //   } else {
      //     data.photo = "";
      //   }
      // }
      //console.log(data);
      return data;
    });
  },

  async loadStudentListByClassId(vuexContext, classId) {
    return await getStudentListByClassId(classId).then(async (response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.fullName = item.firstName + " " + item.lastName;
      });
      return data;
    });
  },

  async deleteStudentClass(vuexContext, obj) {
    return await deleteStudentClass(obj).then(async (response) => {
      let data = response.data.data;
      return data;
    });
  },

  async updateStudent(vuexContext, data) {
    //let formData = new FormData();
    //formData.append("Id", data.userStudentUpdateDto.id);
    // formData.append("Id", data.id);
    // formData.append("Email", data.email);
    // formData.append("FirstName", data.firstName);
    // formData.append("LastName", data.lastName);
    // formData.append("citiesId", data.cityId);
    // formData.append("NationalitysId", data.nationalitysId);
    // formData.append("NationalitysId2", data.nationalitysId2);
    // formData.append("NationalitysId3", data.nationalitysId3);
    // formData.append("GenderId", data.genderId);
    // formData.append("File", data.File);
    // formData.append("Tel", data.tel);
    // formData.append("DateOfBirth", data.dateOfBirth);
    // formData.append("Adress", data.adress);

    return await updateStudent(data).then(async (response) => {
      let datas = response;
      return datas;
    });
  },

  async changeCenter(vuexContext, data) {
    return await changeCenter(data).then(async (response) => {
      let data = response.data.data;
      return data;
    });
  },

  async changeCenterPeriod(vuexContext, data) {
    return await changeCenterPeriod(data).then(async (response) => {
      let data = response.data.data;
      return data;
    });
  },

  addStudentList(vuexContext, data) {
    vuexContext.commit("setStudentList", data);
  },

  addStudentModel(vuexContext, data) {
    vuexContext.commit("setStudentModel", data);
  },

  addNewStudentModel(vuexContext, data) {
    vuexContext.commit("setNewStudentModel", data);
  },

  addStudentInfoModel(vuexContext, data) {
    vuexContext.commit("setStudentInfoModel", data);
  },

  addSelectedStudents(vuexContext, data) {
    vuexContext.commit("setSelectedStudents", data);
  },

  addStudentAssignModel(vuexContext, data) {
    vuexContext.commit("setStudentAssignModel", data);
  },

  addFindStudentModel(vuexContext, data) {
    vuexContext.commit("setStudentModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
